import { render, staticRenderFns } from "./show.participants.page.vue?vue&type=template&id=4edcd9cc&scoped=true&"
import script from "./show.participants.page.vue?vue&type=script&lang=js&"
export * from "./show.participants.page.vue?vue&type=script&lang=js&"
import style0 from "./show.participants.page.vue?vue&type=style&index=0&id=4edcd9cc&scoped=true&lang=scss&"
import style1 from "./show.participants.page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcd9cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
